export default [
  {
    title: 'Operações',
    icon: 'SettingsIcon',
    action: 'read',
    resource: 'Operações',
    children: [
      {
        title: 'Pedidos de Vendas',
        route: 'pedidos-vendas',
        icon: 'CircleIcon',
        action: 'read',
        resource: 'PedidosVenda',
      },
      // {
      //     title: 'Pedidos Padrão',
      //     route: 'pedidos-vendas-padrao',
      //     icon: 'CircleIcon',
      //     action: 'read',
      //     resource: 'PedidosVendaPadrao',
      // },
      {
        title: 'Painel Pic',
        route: 'apps-painel-pic-list',
        icon: 'CircleIcon',
        action: 'read',
        resource: 'PainelPic',
      },
      {
        title: 'Pic',
        route: 'apps-pic-list',
        icon: 'CircleIcon',
        action: 'read',
        resource: 'Pic',
      },
    ],
  },
];
